import editor from "./editor";
import graph from "./graph";
import list from "./list";
import needs from "./needs";
import node from "./node";

export default { list, editor, needs, graph, node };
